export default "__VITE_ASSET__Cfior7qE__"